<template>
  <div class='oversea'>
    <kr-login v-if="activtyData.ActivityType==0" :data="activtyData" :isPC="isPC"/>
    <kr-address v-if="activtyData.ActivityType==1" :data="activtyData" :isPC="isPC"/>
  </div>
</template>
<script>

import KrLogin from "@/components/activity/promotions/krlogin.vue";
import KrAddress from "@/components/activity/promotions/kraddress.vue";
export default {
  name: '',
  components: {KrLogin,KrAddress},
  data() {
    return {
      ua:'',
      route:'',
      isPC:false,
      user: { AreaCode: '', Id: '' },
      activtyData:{ActivityType:'',AreaCode:''}
    }
  },
  watch: {},
  mounted() {},
  created() {
    this.pcShow()
    this.user.Id = (this.$route.query.Id && this.$route.query.Id != 'undefined') ? this.$route.query.Id : ''
    this.user.AreaCode = (this.$route.query.AreaCode && this.$route.query.AreaCode != 'undefined') ? this.$route.query.AreaCode : ''
    this.activtyData={ActivityType:this.$route.params.id,...this.user}
  },
  methods: {
    pcShow(){
      let that=this
      let ua = navigator.userAgent.toLowerCase();
      that.ua=ua
      if(ua.indexOf('windows') > -1||ua.indexOf('intel mac os')>-1){
        that.isPC=true
      }
    },
    ShippingFee() {
      let that = this
      let ua = navigator.userAgent.toLowerCase();
      console.log('ua', ua)
      //android终端
      let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1 || ua.indexOf('android') > -1 || ua.indexOf('adr') > -1;
      console.log('isAndroid', isAndroid)
      //ios终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

      let data = that.activtyData
      if (!isAndroid) {
        //ios
        console.log(" 我是ios")
        //这里是和IOS商量好的写法，调用IOS的finishActivity方法
        try {
          window.webkit.messageHandlers.GetActivityDetail.postMessage(data)
        } catch (error) {
          console.log('WKWebView post message');
        }
      } else if (isAndroid) {
        //android
        console.log("我是android", JSON.stringify(data));
        //这里是和安卓商量好的写法，调用安卓的finishActivity方法
        //android.PayCallback('我是android测试传值');           
        android.GetActivityDetail(JSON.stringify(data));
      }
    }
  },
}

</script>
<style scoped>
.oversea img {
  width: 100%;
  display: block;
  overflow: hidden;
}

.oversea>div.btn {
  position: relative;
  width: 200px;
  height: 50px;
  background: #f00;
  color: #fff;
  text-align: center;
  line-height: 50px;
  margin-left: 45vw;
  margin-top: 45vh;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/promotions/promotion.vue